var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgGenerica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.856,
    height: 94.94,
    viewBox: "0 0 85.856 94.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_generica",
    transform: "translate(0 0.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(0 13.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M2391.354,1473.877h-6.968a32.826,32.826,0,0,0-10.211-23.719,35.826,35.826,0,0,0-49.3,0l-4.926-4.745a43,43,0,0,1,59.155,0A39.39,39.39,0,0,1,2391.354,1473.877Z",
    transform: "translate(-2319.949 -1433.625)",
    fill: "current",
    stroke: "current"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_49",
    d: "M13.977,40.277h-.016V26.844h6.988V40.277c0,11.09,9.34,20.113,20.895,20.113s20.918-9.023,20.918-20.113h6.973c0,14.809-12.473,26.824-27.891,26.824C26.449,67.1,13.977,55.086,13.977,40.277ZM.035,40.262V26.844H0C0,12.02,12.516,0,27.918,0,43.3,0,55.777,12.02,55.777,26.844v15.1h.016a10.467,10.467,0,0,1-20.918,0v-15.1a6.967,6.967,0,0,0-13.926,0H13.961A13.689,13.689,0,0,1,27.918,13.426,13.7,13.7,0,0,1,41.867,26.844v15.1a3.479,3.479,0,0,0,6.953,0v-15.1c0-11.125-9.348-20.129-20.9-20.129S7,15.719,7,26.844V40.262H6.988a32.585,32.585,0,0,0,7.645,20.961L9.2,65.418A38.988,38.988,0,0,1,.035,40.262Z",
    transform: "translate(1.669 26.838)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_39",
    d: "M63.2,73.809V53.68h6.988V73.809Zm0-20.129C63.2,27.746,41.352,6.719,14.41,6.719A50.065,50.065,0,0,0,1.809,8.3L0,1.813A57.731,57.731,0,0,1,14.41,0c30.8,0,55.762,24.027,55.762,53.68Z",
    transform: "translate(15.169)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGenerica);
export default __webpack_public_path__ + "static/media/img_generica.7f1df853.svg";
export { ForwardRef as ReactComponent };